module.exports = __webpack_public_path__ + "static/media/speaker.e58e94dd.svg";